import { createBrowserHistory } from 'history';
import React from 'react';
import { render } from 'react-dom';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

import configureAppStore from './redux/store';
import App from './App';
import { getFirebaseAuth } from './lib/firebase';

const history = createBrowserHistory();
const { store } = configureAppStore();
getFirebaseAuth();

// Clear bgLocation from location.state during app initialization
if (history.location.state?.bgLocation) {
  let state = { ...history.location.state };
  delete state.bgLocation;
  history.replace({ ...history.location, state });
}

render(
  <HistoryRouter history={history}>
    <App history={history} store={store} />
  </HistoryRouter>,
  document.getElementById('app'),
);

if (module.hot) {
  module.hot.accept();
}
